import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import CrewExtraRow from '@/components/Forms/QuestionType/CrewExtraRow.vue';
import { RolePrevExpValue } from '@/components/Forms/QuestionType/CrewType';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrewExtraExperience',
  props: {
  value: {
    type: Array as PropType<Array<RolePrevExpValue>>,
    required: true,
  },
  ranks: {
    type: Array as PropType<Array<string>>,
    required: true,
  },
},
  emits: {
  input: (value: Array<RolePrevExpValue>) => Array.isArray(value),
},
  setup(__props, { emit }) {

const props = __props;




function remove(idx: number) {
  emit(
    'input',
    props.value.filter((_, i) => i !== idx)
  );
}
function update(idx: number, value: RolePrevExpValue) {
  emit(
    'input',
    props.value.map((v, i) => (i === idx ? value : v))
  );
}
function add() {
  emit('input', [
    ...props.value,
    { rank: props.ranks[0], size: 'Handymax', time: '' },
  ]);
}

return { __sfc: true,props, emit, remove, update, add, CrewExtraRow }
}

})